import { render, staticRenderFns } from "./ProductLocalCustomerCreateForm.vue?vue&type=template&id=6e808f2c&"
import script from "./ProductLocalCustomerCreateForm.vue?vue&type=script&lang=js&"
export * from "./ProductLocalCustomerCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e808f2c')) {
      api.createRecord('6e808f2c', component.options)
    } else {
      api.reload('6e808f2c', component.options)
    }
    module.hot.accept("./ProductLocalCustomerCreateForm.vue?vue&type=template&id=6e808f2c&", function () {
      api.rerender('6e808f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductLocalCustomerCreateForm.vue"
export default component.exports